/* eslint-disable object-curly-newline */
import shoppingCartApi from '@/api/shopping-cart';
import { storeActionCommit } from '@/utils/common-utils';

export default {
  createShoppingCart({ commit }, { shoppingCart, errorManagementType }) {
    return shoppingCartApi.createShoppingCart(shoppingCart, errorManagementType)
      .then((response) => {
        const lockVerion = 1;
        localStorage.setItem('x-cart', response.id);

        shoppingCart.id = response.id;
        shoppingCart.lockVerion = lockVerion;
        return storeActionCommit(commit, 'setShoppingCart')(shoppingCart);
      });
  },

  fetchShoppingCart({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return shoppingCartApi.fetchShoppingCart(id, idType, errorManagementType)
      .then((shoppingCart) => {
        // localStorage.setItem('x-cart', shoppingCart.account.id);
        return storeActionCommit(commit, 'setShoppingCart')(shoppingCart);
      });
  },
  // `storeActionCommit(commit, type)` RETURNS the committer, so calling it with
  // `(shoppingCart)` runs the commit immediately and hands `.then()` the
  // undefined result — the commits fired before the request had even been sent,
  // and fired just the same when it failed. `lockVersion` was therefore bumped
  // locally on every failed PUT, drifting ahead of the server's; with optimistic
  // locking that makes the NEXT PUT fail too, so one failure left the cart in a
  // state that could never recover and error notifications kept stacking up
  // across navigations. Commit only once the write actually succeeded.
  updateShoppingCart({ commit }, { id, shoppingCart, errorManagementType }) {
    return shoppingCartApi.updateShoppingCart(id, shoppingCart, errorManagementType)
      .then(() => {
        storeActionCommit(commit, 'setShoppingCart')(shoppingCart);
        return storeActionCommit(commit, 'setCartLockVersion')(shoppingCart.lockVersion + 1);
      });
  },

  addProductToShoppingCart({ commit }, { id, product, errorManagementType }) {
    return shoppingCartApi.addProductToShoppingCart(id, product, errorManagementType)
      .then(() => storeActionCommit(commit, 'addProduct')(product));
  },
  reserveProductToCart({commit}, { product, errorManagementType }) {
    return shoppingCartApi.reserveProductToCart(product, errorManagementType)
      .then((response) => {
        if (response && response.puid) {
          const reservedProductIds = JSON.parse(localStorage.getItem('reservedProductIds')) || [];
          reservedProductIds.push(response.puid);
          localStorage.setItem('reservedProductIds', JSON.stringify(reservedProductIds));
        }
        return storeActionCommit(commit, 'addReservedProduct')(product);
      });
  },

  emptyShoppingCart({ commit }) {
    localStorage.removeItem('x-cart');
    return storeActionCommit(commit, 'setShoppingCart')(null);
  },

  updateLocalCartProducts({ commit }, payload) {
      commit('SET_LOCAL_CART_PRODUCTS', payload);
      const countryCode = localStorage.getItem("countryCode");
      const key = "cartProducts" + countryCode;
      // Never persist a null/undefined payload: JSON.stringify(null) writes the
      // four-character string "null", which every reader then JSON.parses back
      // to null. initStore() reads this key and writes it straight back on every
      // boot, so one null read used to poison the key permanently — the cart
      // mirror stayed "null" until an add-to-cart happened to overwrite it.
      if (payload == null) {
        localStorage.removeItem(key);
        return;
      }
      localStorage.setItem(key, JSON.stringify(payload));
    },


};
